import { useQuery } from 'react-query'
import { QUERY_KEYS } from 'src/constants'
import { userService } from 'src/services/user.service'

const useGetUserProviders = () => {
  return useQuery([QUERY_KEYS.USER_PROVIDERS], () => userService.getUserProviders(), {})
}

export { useGetUserProviders }
